module.exports = __webpack_public_path__ + "images/tips/info-image-04@1x.4c0a774936d0d1148251.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-04@1x.png
// module id = 6A/9
// module chunks = 13